import { SearchableSelectField } from "@certn/cascadia-react";
import { usePeopleAPI } from "@certn/legacy-api";
import { Field } from "formik";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Item } from "react-stately";

type CountrySelectProps = {
  name: string;
  label: string;
  isRequired?: boolean;
  testID?: string;
  onChange?: (value: string) => void;
  onFilter?: (country: { alpha_2: string; name: string }) => boolean;
  placeholder?: string;
};

export function CountrySelect({
  name,
  label,
  isRequired,
  testID,
  placeholder,
  onChange,
  onFilter,
}: CountrySelectProps) {
  const { t } = useTranslation();
  const { data: countryList, isLoading: countriesLoading } = usePeopleAPI(
    "/internal/people/addresses/countries/"
  );

  const sortedCountryList = useMemo(
    () => countryList?.sort((a, b) => a.name.localeCompare(b.name)),
    [countryList]
  );

  return (
    <Field
      name={name}
      label={label}
      as={SearchableSelectField}
      isRequired={isRequired}
      onChange={onChange}
      testID={testID}
      placeholder={placeholder ?? t("Please select")}
    >
      {countriesLoading ? (
        <Item key="Loading">{t("Loading...")}</Item>
      ) : (
        sortedCountryList
          ?.filter((country) => (onFilter ? onFilter(country) : true))
          .map((country) => <Item key={country.alpha_2}>{country.name}</Item>)
      )}
    </Field>
  );
}
